<template>
  <div class="container en023">
    <NoticeBox class="-cancel _mb-md-120 _mb-sm-60 _mt-md-60 _mt-sm-15">
      <NoticeHeader>
        <h1 class="heading">誠に申し訳ございませんが、ご利用いただけません</h1>
      </NoticeHeader>
      <NoticeBody>
        <p>●新規お申し込みを希望されたお客さまへ</p>
        <p>お申し込み条件を満たしていないため、au PAY スマートローンにお申し込みいただけません。</p>
        <p>【お申し込み条件】</p>

        <ListGroup class="-normal">
          <ListItem class="-normal">
            ご本人さま名義のau IDをお持ちのお客さま（法人契約でご利用のau IDではお申し込みいただけません）
          </ListItem>
          <ListItem class="-normal">満20歳以上、70歳以下のお客さま</ListItem>
          <ListItem class="-normal">ご本人さまに定期収入のある方</ListItem>
          <ListItem class="-normal">携帯電話をお持ちのお客さま</ListItem>
          <ListItem class="-normal">現住所が国内にある方</ListItem>
        </ListGroup>
        <ListGroup class="-note _mb-50">
          <ListItem class="-note">年金を受給されている場合は、年金以外に安定した収入がある方に限ります。</ListItem>
          <ListItem class="-note important">ご利用時にSMSの追加認証がございます。</ListItem>
          <ListItem class="-note">au PAY カードをお持ちで、キャッシングサービス/キャッシング月々返済（カードローン）をお申し込み中、またはすでに設定されている方は、お申し込みいただけない場合がございます。</ListItem>
        </ListGroup>

        <p>●会員さま専用サイトへアクセスいただいたお客さまへ</p>
        <p class=" _mb-50">既に退会となっているお客さまは、会員サイトへログインいただけません。</p>

        <p>ご期待に沿えず誠に申し訳ございませんが、何卒ご理解いただきますようお願い申しあげます。</p>
      </NoticeBody>
    </NoticeBox>
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeBody from "@/components/box/NoticeBody";
import NoticeHeader from "@/components/box/NoticeHeader";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";

export default {
  name: "En023",
  components: {
    ListItem,
    ListGroup,
    NoticeHeader,
    NoticeBody,
    NoticeBox,
  },
  setup() {
    setMeta({
      title: "au PAY スマートローン",
      titleTemplate: null,
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会",
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.notice-box {
  &.-cancel {
    .notice-body {
      text-align: left;
    }
  }
}
.important {
  color: $red;
}
</style>
